<template>
  <k-panel>
    <template #left-buttons>
      <k-tabs large>
        <k-tab name="devices" to="/devices/devices" label="Devices"></k-tab>
        <k-tab name="plan" to="/devices/plan" label="Plan"></k-tab>
        <k-tab name="models" to="/devices/models" label="Models">
          <template #submenu>
            <div v-for="(device_type, index) in device_types" :key="index">
              <k-btn tile flat :to="get_model_to_uri(device_type)" :id="device_type">{{device_type.title}}</k-btn>
            </div>
          </template>
        </k-tab>

        <k-tab name="locations" to="/devices/locations" label="Locations"></k-tab>

      </k-tabs>

<!--
      <k-btn flat to="/devices/devices"> Devices </k-btn>
      <k-btn flat to="/devices/plan"> Plan </k-btn>
 
      <k-menu offset-y v-if="$is_admin()">
        <template slot="activator" slot-scope="{ on }">
          <k-btn v-on="on" flat class="pr-1" v-model="$route.path.startsWith('/devices/models')"> Models <k-icon>arrow_drop_down</k-icon> </k-btn>
        </template>
        <div>
          <k-btn list flat tile :to="get_model_to_uri(device_type)" v-for="(device_type, index) in device_types" :key="index" :id="device_type">{{device_type.title}}</k-btn>
        </div>
      </k-menu>
      <k-btn flat to="/devices/locations"> Locations </k-btn>-->
    </template>
    <template #default>
      <router-view></router-view>
    </template>
  </k-panel>
</template>

<script>

/*import DeviceList from './devices/List'
import DevicePlan from './devices/Plan'
import DeviceModels from './devices/Models'
import DeviceLocations from './devices/Locations'
import DeviceRead from './devices/Read'
import DeviceEditor from './devices/Editor'
import ListDataEditor from './content/ListDataEditor'*/

import DevicesPage from './devices/Devices'
import ModelsPage from './devices/Models'
import PlanPage from './devices/Plan'
import LocationsPage from './devices/Locations'
import SettingsModel from '@/models/settings.js';


export default {
	computed: {
		device_types () {
			return SettingsModel.list("device_type");
		}
	},
	methods: {
		get_model_to_uri(device) {
      var form = device.value.form;
      var fitem = _.find(form, function(f) {
        return f.name == "model";
      })
      var content_list_id = fitem.content_id;
			return "/devices/models/list/" + content_list_id;
		}
	},
	routes: [
		{
			path: '',
			redirect: 'devices'
		},
  	{
      path: 'devices',
      component: DevicesPage,
      children: DevicesPage.routes
    },
    {
    	path: 'models',
    	component: ModelsPage,
    	children: ModelsPage.routes
    },
    {
    	path: 'plan',
    	component: PlanPage,
    	children: PlanPage.routes
    },
    {
    	path: 'locations',
    	component: LocationsPage,
    	children: LocationsPage.routes
    }
   ]
}
</script>
